import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import Info from '../../components/info/Info';

const hero = () => {
  return (
    <div>
      <HeroSection />
      <Info />
      {/* <ShineyWaves /> */}
    </div>
  );
};

export default hero;
